import Api from '@/services/Api';

const RECURSO = '/mapa';
export default {
    buscarSingularidadesPorSub,
};

function buscarSingularidadesPorSub () {
    return Api.get(`${RECURSO}/singularidades`);
}